import React from 'react';
import PropTypes from 'prop-types';

import Spinner from './Spinner';

const Loading = ({ inline, small, classes }) => {
  if (small) {
    return <Spinner />;
  }

  if (inline) {
    // This one is shown inline with a component, such as a 'submit' button
    return <Spinner classes={`tiny-spinner ${classes}`} />;
  }

  // This one will be the 'float above' spinner that doesn't affect the UI
  return <Spinner classes={classes} />;
};

Loading.propTypes = {
  inline: PropTypes.bool,
  small: PropTypes.bool,
  classes: PropTypes.string,
};

Loading.defaultProps = {
  inline: false,
  small: false,
  classes: '',
};

export default Loading;
